import { useIsGuestUser, useUser } from '@/features/account/services/User/hooks'
import { useQueryIncompleteOrders } from '@/features/shop/services/Orders/queries'

/**
 * Returns true if all eligible operational modal conditions have been
 * met. False means that not all data has been fetched or a modal might
 * need to be opened. This does not include checking if a modal is
 * currently open which should be done imperatively.
 */
export function useCanDisplayCMSModal(suppress = false): boolean {
  const isGuestUser = useIsGuestUser()
  const user = useUser()
  const { data: incompleteOrders, isEnabled } = useQueryIncompleteOrders()

  if (suppress) return false
  // no operational modals are shown to guest users
  if (isGuestUser) return true

  // user has not fetched yet
  if (!user) return false

  // post order tipping/rating
  if (isEnabled && user.has_placed_marketplace_order) {
    // if incomplete orders have not yet fetched,
    // we need to wait because post-order flows always take priority
    if (!incompleteOrders) return false
    // if there are incomplete orders to tip/rate
    if (incompleteOrders.length) return false
  }

  return true
}
